<template>
  <div class="third-page">
    <CustomTitle :title="'专业领域'" :sub-title="'为客户提供竞争优势的法律解决方案'"></CustomTitle>
    <div class="list">
      <div class="item" v-for="(item,index) in imgList" :key="index" :style="{backgroundImage: `url(${item.img})`, backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat', backgroundPosition: 'center center'}">
        <div class="name">{{item.title}}</div>
      </div>
    </div>
    <div class="more" @click="learnMore">了解更多 →</div>
    <div class="pageNum">
      <img width="26px" height="13px" src="../../assets/homePage/home_icon_npage_b.png" @click="goNextPage"/>
    </div>
  </div>
</template>

<script>
import CustomTitle from "@/components/CustomTitle";
import qy from '@/assets/img/qy.png'
import mssss from '@/assets/img/mssss.png'
import blzczz from '@/assets/img/blzczz.png'
import zscqwq from '@/assets/img/zscqwq.png'
import jrzq from '@/assets/img/jrzq.png'
export default {
  name:'cooperativePartner',
  components:{CustomTitle},
  data() {
    return {
      imgList:[
        {
          title: '企业法律事务',
          img: qy,
        },
        {
          title: '民商事诉讼',
          img: mssss,
        },
        {
          title: '不良资产处置',
          img: blzczz,
        },
        {
          title: '知识产权维权',
          img: zscqwq,
        },
        {
          title: '金融证券',
          img: jrzq,
        },

      ]
    };
  },
  methods: {
    goNextPage() {
      this.$emit('next-page'); // 触发一个事件，通知父组件跳转到下一页
    },
    learnMore() {
      this.$router.push({
        path: '/professionalField',
      })
    }
  }
};
</script>

<style lang="scss">
.third-page{
  width: 100%;
  height: 100vh;
  background:url("../../assets/img/yhyy.png") no-repeat center center;
  background-size: cover; /* 确保背景图填满 */
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 10vh 10vw;
  box-sizing: border-box;

  .list{
    display: flex;
    justify-content: space-between;
    margin: 5% 0px;
    width: 100%;
    .item{
      width: 17vw;
      height: 50vh;
      transition: all 0.3s ease; /* 添加过渡效果 */
      .name{
        font-weight: 600;
        font-size: 24px;
        color: #FFFFFF;
        line-height: 28px;
        padding: 24px;
        position: relative;
      }
      .name::after{
        content: '';
        position: absolute;
        bottom: -2px;
        left: 24px;
        width: 24px;
        height: 4px;
        background: #fff;
      }
      .line{
        width: 24px;
        height: 6px;
        background: #224DF4;
        margin-left: 24px;
      }
    }

    .item:hover{
      background: url('../../assets/img/hover.png') no-repeat center center!important;
      backgroundSize: 100% 100%
    }
  }
  .pageNum{
    width: calc(100% - 20vw);
    text-align: center;
    position: absolute;
    bottom: 20px;
    cursor: pointer;
  }

  .more{
    cursor: pointer;
  }
}
</style>
